import Swiper from 'swiper'
import { Pagination } from 'swiper/modules'

import 'swiper/swiper-bundle.min.css'

if (!document.querySelector('#carousel-testimonials')) {
  return
}

new Swiper('#carousel-testimonials', {
  pagination: {
    el: '.swiper-pagination',
    dynamicBullets: true,
  },
  autoHeight: true,
  spaceBetween: 20,
  modules: [Pagination],
})
